// extracted by mini-css-extract-plugin
export default {"editButton":"advanceSalaryInstallment_editButton__wP-jb","TableBody":"advanceSalaryInstallment_TableBody__XV6wk"};